import { Project } from '../interfaces/project.interface';
import { technologies } from './technologies';

export let projects: Project[] = [
  {
    name: 'Zynyo',
    logo: '/assets/images/projects/zynyo/zynyo-logo.png',
    description: 'Zynyo is a signing service for digital documents, available also in Sharepoint as an Add-In. I contributed in the development of the Sharepoint Add-In frontend behavior.',
    contributions: [
      'Improvements to old Sign Request Wizard',
      'Implementation of new design in Sign Request Wizard'
    ],
    technologies: [
      technologies.SEMANTICUI,
      technologies.JAVASCRIPT,
      technologies.ANGULAR
    ],
    projectSlug: 'zynyo',
    projectUrl: 'https://zynyo.com/',
    projectImages: [
      '/assets/images/projects/zynyo/project-images/Screenshot 2023-01-04 at 14-49-25 Digitale Handtekening geavanceerd en gekwalificeerd ondertekenen.png'
    ],
    thumbnail: '/assets/images/projects/zynyo/zynyo-thumbnail.jpg'
  },
  {
    name: 'Elemento 43',
    logo: '/assets/images/projects/e43/e43-logo.png',
    description: 'I Contributed with the construction of the website for the software development company Elemento 43 using Wordpress.',
    contributions: [
      'Design & implementation of Wordpress website',
      'Maintenance and constant support to the frontend look and feel'
    ],
    technologies: [
      technologies.BOOTSTRAP,
      technologies.JAVASCRIPT,
      technologies.PHP,
      technologies.WORDPRESS
    ],
    projectSlug: 'elemento-43',
    projectUrl: 'https://elemento43.com/',
    projectImages: [
      '/assets/images/projects/e43/project-images/Screenshot 2023-01-04 at 14-39-38 Elemento 43.png'
    ],
    thumbnail: '/assets/images/projects/e43/e43-thumbnail.jpg'
  },
  {
    name: 'Zero',
    logo: '/assets/images/projects/zero/zero-logo.png',
    description: 'I implemented the design for this Dutch company named Zero, in charge of advertisement and marketing.',
    contributions: [
      'Static design implementation based on designs given',
      'Wordpress theme implementation'
    ],
    technologies: [
      technologies.BOOTSTRAP,
      technologies.JAVASCRIPT,
      technologies.PHP,
      technologies.WORDPRESS
    ],
    projectSlug: 'zero',
    projectUrl: 'https://wearezero.co/',
    thumbnail: '/assets/images/projects/zero/zero-thumbnail.jpg'
  },
  {
    name: 'Osorio Asesorias',
    logo: '/assets/images/projects/osorio-asesorias/osorioasesorias-logo.png',
    description: 'Osorio Asesorias is an attorney website, the solution I contributed here was developing an informative website using Wordpress.',
    contributions: [
      'Wordpress theme design from scratch'
    ],
    technologies: [
      technologies.BOOTSTRAP,
      technologies.JAVASCRIPT,
      technologies.PHP,
      technologies.WORDPRESS
    ],
    projectSlug: 'osorio-asesorias',
    projectImages: [
      '/assets/images/projects/osorio-asesorias/project-images/Screenshot 2023-01-04 at 14-47-07 Osorio Asesorias.png'
    ],
    projectUrl: 'http://osorioasesorias.com/',
    thumbnail: '/assets/images/projects/osorio-asesorias/osorio-asesorias-thumbnail.jpg'
  },
  {
    name: 'Expivi',
    logo: '/assets/images/projects/expivi/expivi-logo.png',
    description: 'Expivi is a dutch company which offers a specialized service, 3D models for products in E-Commerce websites, making them stand out of the normal E-Commerce websites.',
    contributions: [
      'Frontend implementation of custom code to work on Bigcommerce website'
    ],
    technologies: [
      technologies.BOOTSTRAP,
      technologies.JAVASCRIPT,
      technologies.PHP,
      technologies.LARAVEL
    ],
    projectSlug: 'expivi',
    projectUrl: 'https://expivi.com/',
    projectImages: [
      '/assets/images/projects/expivi/project-images/Screenshot 2023-01-04 at 14-33-20 Expivi 3D Product Configurator Expivi - Customize anything.png',
      '/assets/images/projects/expivi/project-images/Screenshot 2023-01-04 at 14-32-24 Expivi 3D Product Configurator Expivi - Customize anything.png'
    ],
    thumbnail: '/assets/images/projects/expivi/expivi-thumbnail.jpg'
  },
  {
    name: 'Ping Ping',
    description: 'This is an educative program of the Dutch municipality for instruct teenagers about how to handle and get into a healthy financial life.',
    contributions: [
      'Mobile application implementation from scratch based on given designs'
    ],
    technologies: [
      technologies.BOOTSTRAP,
      technologies.JAVASCRIPT,
      technologies.ANGULAR
    ],
    projectSlug: 'pingping',
    projectUrl: 'https://pingping.amsterdam.nl/',
    projectImages: [
      '/assets/images/projects/ping-ping/project-images/Screenshot 2023-01-04 at 13-56-38 Ping Ping.png'
    ],
    thumbnail: '/assets/images/projects/ping-ping/ping-ping-thumbnail.jpg'
  },
  {
    name: 'Involved Studio',
    logo: '/assets/images/projects/involved-studio/involved-studio-logo.png',
    description: 'Entrepreneurship to offer website hosting and software development services for small and medium businesses.',
    contributions: [
      'Implementation of WHCMS website',
      'Design and implementation of website from scratch'
    ],
    technologies: [
      technologies.BOOTSTRAP,
      technologies.JAVASCRIPT,
      technologies.PHP,
      technologies.WORDPRESS,
      technologies.TAILWINDCSS
    ],
    projectSlug: 'involved-studio',
    projectImages: [
      '/assets/images/projects/involved-studio/project-images/Screenshot 2023-01-04 at 14-37-06 Involved Studio.png'
    ],
    projectUrl: 'https://involvedstudio.com/',
    thumbnail: '/assets/images/projects/involved-studio/involved-studio-thumbnail.jpg'
  }
];
